import { track } from "../track";

export const trackAvatarDeleteClick = (params: { avatar_id: string }) =>
  track({ event: "avatar_delete_click", ...params });
